import React from "react";
import { connect } from "react-redux";

import { clearBreadcrumbs } from "reducers/view";

class Home extends React.Component {
  constructor() {
    super(...arguments);
    this.props.clearBreadcrumbs();
  }

  render() {
    return <p>Welcome</p>;
  }
}

export default connect(
  (state) => {
    return {
      supplier: state.supplier.all,
    };
  },
  { clearBreadcrumbs }
)(Home);
